import type {Schema} from 'schemaDefinition/types';
import type {ThesaurusesMap} from 'services/thesaurus/types';
import {useSchemaDataAccess} from '../contexts';
import {useSchemaThesaurusIds} from './useSchemaThesaurusIds';

/**
 * Assumes needed thesauruses have been loaded
 * @param schema
 * @returns
 */
export const useSchemaThesauruses = (
  schema: Schema | undefined,
): ThesaurusesMap => {
  const thesaurusIds = useSchemaThesaurusIds(schema);
  return useSchemaDataAccess().useThesauruses(thesaurusIds);
};
